<div class="di-toolbar px-8" fxFlex>
    <!-- Phone only: the navbar sidebar is an overlay below 1280px but nothing on the bar opened it. -->
    <button class="di-topbar-btn di-mobile-only" type="button" aria-label="Menu" (click)="toggleSidebarOpen('navbar')">
        <mat-icon>menu</mat-icon>
    </button>
    <div class="logo" fxLayout="row" fxLayoutAlign="center center">
        <img
            class="logo-icon"
            [src]="is_dark_mode ? 'assets/images/logos/new-logo-full-dark.png' : 'assets/images/logos/new-logo-full.png'"
            (click)="goHome()" />
    </div>
    <div fxLayout="row" fxLayoutAlign="start center" class="tenant" style="margin-left: 16px">
        {{ tenant }}
    </div>
    <!-- Phone only: opens the cluster below as a bottom sheet. Nothing is dropped, it just moves. -->
    <button class="di-topbar-btn di-mobile-only" type="button" aria-label="More" (click)="mobileActionsOpen = !mobileActionsOpen">
        <mat-icon>more_vert</mat-icon>
    </button>

    <div fxFlex fxFill fxLayout="row" fxLayoutAlign="end center" class="di-toolbar-actions" [class.open]="mobileActionsOpen">
        <div class="radio" fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="start center">
            <button
                *ngIf="showStaffActions || (isUserCustomer && !isSuperuser && (customerTrackOrderEnabled$ | async))"
                nz-button
                nzType="primary"
                class="mx-8 mb-6"
                (click)="trackOrder(); mobileActionsOpen = false"
                nz-tooltip
                nzTooltipTitle="Track Order"
                nzTooltipPlacement="bottom">
                <mat-icon>map</mat-icon>
                <span class="di-toolbar-label di-mobile-only">Track Order</span>
            </button>

            <button
                *ngIf="showStaffActions"
                nz-button
                class="mx-8 mb-6"
                (click)="openCheckRouteModal(); mobileActionsOpen = false"
                nz-tooltip
                nzTooltipTitle="Check Route"
                nzTooltipPlacement="bottom">
                <fa-icon [icon]="faRoute"></fa-icon>
                <span class="di-toolbar-label di-mobile-only">Check Route</span>
            </button>

            <button nz-button class="mx-8 mb-6 action-bar-button" *ngIf="showStaffActions && (addOrderRoleKey$ | async | roleShow | async)">
                <div style="width: 100%" class="toolbar-icon-group-short">
                    <div
                        class="toolbar-icon-slot"
                        (click)="addNewOrder(); mobileActionsOpen = false"
                        fxFlex="75"
                        nz-tooltip
                        nzTooltipTitle="Add Order"
                        nzTooltipPlacement="bottom">
                        <span class="di-mi di-mobile-only">add</span>
                        <span class="di-toolbar-label di-mobile-only">Add Order</span>
                        <span class="di-desktop-only">Add Order</span>
                    </div>
                    <div
                        class="toolbar-icon-slot add-order-icon"
                        (click)="addNewOrderWindowed(); mobileActionsOpen = false"
                        fxFlex="25"
                        nz-tooltip
                        nzTooltipTitle="Add Order Windowed"
                        nzTooltipPlacement="bottom">
                        <i nz-icon nzType="layout"></i>
                        <span class="di-toolbar-label di-mobile-only">Add Order Windowed</span>
                    </div>
                </div>
            </button>

            <form *ngIf="showStaffActions" nz-form [formGroup]="quickSearchForm">
                <div class="searchDiv">
                    <!-- <input type="checkbox" formControlName="filterDates" />
                    <span>FilterDates</span> -->
                    <di-checkbox field="filterOnDates"></di-checkbox>
                    <input type="radio" value="ORDER" formControlName="searchType" />
                    <span>Order</span>
                    <input type="radio" value="RUN" formControlName="searchType" *ngIf="!isUserCustomer" />
                    <span *ngIf="!isUserCustomer">Run</span>
                    <div class="searchInput">
                        <nz-input-wrapper>
                            <input type="text" nz-input #searchInput formControlName="searchQuery" (keyup)="onSearchValueChange()" />
                            <a nzInputSuffix (click)="clearSearch()"
                                ><i style="color: var(--brand-color) !important" *ngIf="!searchTermIsEmpty" nz-icon nzType="close-circle"></i
                            ></a>
                        </nz-input-wrapper>
                    </div>
                    <button nz-button class="mb-6" (click)="onSearch()"><i nz-icon nzType="search" class="mr-2"></i></button>
                </div>
            </form>
            <button *ngIf="showStaffActions" nz-button class="mx-8 mb-6 action-bar-button">
                <div style="width: 100%" class="toolbar-icon-group">
                    <span class="toolbar-icon-slot" [satPopoverAnchor]="notifications" (click)="notifications.toggle()">
                        <nz-badge [nzCount]="(notifications$ | async).length" nzSize="small">
                            <mat-icon>notifications</mat-icon>
                        </nz-badge>
                        <span class="di-toolbar-label di-mobile-only">Notifications</span>
                    </span>
                    <span class="toolbar-icon-slot button-border" [satPopoverAnchor]="login" (click)="login.toggle()">
                        <mat-icon>person</mat-icon>
                        <span class="di-toolbar-label di-mobile-only">User last seen</span>
                        <span class="di-toolbar-meta">{{ (this._loggedInServie.loggedInData | async).length }}</span>
                    </span>

                    <span class="toolbar-icon-slot" [satPopoverAnchor]="bulkProgress" (click)="bulkProgress.toggle()">
                        <nz-badge [nzCount]="(bulkProgress$ | async).length" nzSize="small">
                            <mat-icon>hourglass_empty</mat-icon>
                        </nz-badge>
                        <span class="di-toolbar-label di-mobile-only">Background tasks</span>
                    </span>
                </div>
            </button>

            <span *ngIf="showStaffActions" style="display: flex; align-items: center">
                <span class="di-mi di-mobile-only">smart_toy</span>
                <span class="di-toolbar-label di-mobile-only">{{ askLabel }}</span>
                <hm-assistant-chat></hm-assistant-chat>
                <ai-input></ai-input>
            </span>

            <div class="px-24 py-12">
                <span class="di-mi di-mobile-only">language</span>
                <span class="di-toolbar-label di-mobile-only">Language</span>
                <a nz-dropdown [nzDropdownMenu]="langMenu">
                    <div fxLayout="row" fxLayoutAlign="center center">
                        <img class="flag mr-8" [src]="'assets/images/flags/' + selectedLanguage.flag + '.png'" />
                        <span class="iso text-uppercase">{{ selectedLanguage.id }}</span>
                    </div>
                </a>
                <nz-dropdown-menu #langMenu="nzDropdownMenu">
                    <ul nz-menu nzSelectable>
                        <li nz-menu-item *ngFor="let lang of languages" (click)="setLanguage(lang)">
                            <span fxLayout="row" fxLayoutAlign="start center">
                                <img class="flag mr-16" [src]="'assets/images/flags/' + lang.flag + '.png'" />
                                <span class="iso">{{ lang.title }}</span>
                            </span>
                        </li>
                    </ul>
                </nz-dropdown-menu>
            </div>
        </div>
        <button class="di-toolbar-close di-mobile-only" type="button" (click)="mobileActionsOpen = false">Close</button>
    </div>
</div>

<div class="di-toolbar-backdrop di-mobile-only" *ngIf="mobileActionsOpen" (click)="mobileActionsOpen = false"></div>

<div class="app-version">v{{ appVersionNo }}</div>

<sat-popover horizontalAlign="end" verticalAlign="below" #notifications hasBackdrop>
    <div class="bordered-popover">
        <div class="popover-title" style="margin: 5px">
            <span><b class="title">Notifications</b></span>
            <button nz-tooltip nzTooltipTitle="Mark all as read" (click)="markNotificationsAsRead()">
                <fa-icon [icon]="faBell"></fa-icon>
            </button>
        </div>

        <div style="max-height: 150px; overflow: auto">
            <perfect-scrollbar>
                <div *ngFor="let notification of notifications$ | async" class="notification">
                    <span class="em9">
                        {{ notification.notification }}
                    </span>

                    <span class="em9" style="font-size: 9px">
                        {{ getDateTimeAsString(notification.time) }}
                    </span>
                </div>
            </perfect-scrollbar>
        </div>
    </div>
</sat-popover>

<sat-popover horizontalAlign="end" verticalAlign="below" #bulkProgress hasBackdrop>
    <div class="bordered-popover">
        <div class="popover-title" style="margin: 5px">
            <span><b class="title">Background Tasks</b></span>
        </div>

        <div style="max-height: 150px; overflow: auto">
            <perfect-scrollbar>
                <div style="margin: 20px" *ngFor="let bulkProgress of bulkProgress$ | async" class="notification">
                    <div style="min-width: 300px">
                        <b>{{ bulkProgress.operationName }}</b>
                    </div>
                    <div>Task ID:{{ bulkProgress.id }}</div>
                    <div>
                        <span style="padding-right: 5px">Succeded:{{ bulkProgress.successCount }}</span
                        ><span>Failed:{{ bulkProgress.failureCount }}</span>
                    </div>
                    <nz-progress
                        [nzPercent]="
                            ((bulkProgress.successCount + bulkProgress.failureCount) * 100.0) / bulkProgress.totalCount | roundTotal
                        "></nz-progress>
                </div>
            </perfect-scrollbar>
        </div>
    </div>
</sat-popover>

<sat-popover horizontalAlign="end" verticalAlign="below" #login hasBackdrop>
    <div class="bordered-popover">
        <div class="popover-title" style="margin: 5px">
            <span><b class="title">User Last Seen</b></span>
        </div>

        <div style="max-height: 150px; overflow: auto">
            <perfect-scrollbar>
                <div style="margin: 20px" *ngFor="let userData of this._loggedInServie.loggedInData | async" class="notification">
                    <div>{{ userData.user }}:{{ userData.lastLogin }}</div>
                </div>
            </perfect-scrollbar>
        </div>
    </div>
</sat-popover>
